import React, { useEffect, useCallback, useContext } from 'react';
import { connect } from 'react-redux';

import * as serviceWorker from "./serviceWorker";
import * as actions from './store/actions/index';
import './App.css';
import Layout from './hoc/Layout/Layout';
import { SiteSessionStorage } from './shared/classes/index';
import Routes from './Routes';
import notificationContext from './context/Notification';

export const UnconnectedApp = (props) => {
	const { onTryAutoSignup, setSelectedSite } = props;
	const siteSessionStorage = useCallback(new SiteSessionStorage(), []);
	const [notification, setNotification] = notificationContext.useNotificationContext();

	useEffect(() => {
		serviceWorker.register({
			onUpdate: (registration) => {
				if (registration && registration.waiting) {
					setNotification({ message: "A new version is available!", actions: [ { name: 'Update', handler: handleRefreshForUpdate } ] });
				}
			}
		});
	}, [setNotification]);

	const handleRefreshForUpdate = () => {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker
				.getRegistration()
				.then((reg) => {
					reg.waiting.postMessage({ type: 'SKIP_WAITING' });
					window.location.reload();
				})
				.catch((err) => console.log('Could not get registration: ', err));
		}
	};

	//auto sign in, setting selected site if any
	useEffect(() => {
		onTryAutoSignup();
		const selectedSite = siteSessionStorage.selectedSite;
		if (selectedSite) {
			setSelectedSite(selectedSite);
		}
	}, [onTryAutoSignup, setSelectedSite, siteSessionStorage]);

	return (
		<Layout isAuthenticated={props.isAuthenticated}>
			<Routes isAuthenticated={props.isAuthenticated} />
		</Layout>
	);
}

const mapStateToProps = state => {
	return {
		isAuthenticated: state.auth.token !== null
	}
}

const mapDispatchToProps = dispatch => {
	return {
		onTryAutoSignup: () => dispatch(actions.authCheckState()),
		setSelectedSite: (site) => dispatch(actions.setSelectedSuccess(site))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedApp);